import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import useSnackbar from "../../hooks/useSnackbar.js";
import { createUser } from "../../api/user.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";
import { countries } from "../../config/countries.js";
import { role } from "../../config/roles.js";

const emptyUserData = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  role: "USER",
  city: "",
  state: "",
  zipcode: "",
  address: "",
  address2: "",
  country: "",
};

export default function NewUser() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();

  const { data: user } = useSelector((state) => state.user);

  const [userData, setUserData] = useState(emptyUserData);

  const onInputChange = ({ target }) => {
    setUserData((prev) => ({ ...prev, [target.name]: target.value }));
  };
  const [phoneError, setPhoneError] = useState("");
  const onCreateFormSubmit = async (e) => {
    e.preventDefault();
    if (userData.phone.length !== 10) {
      setPhoneError("Please enter a valid 10-digit phone number");
      return;
    }
    setPhoneError("");
    try {
      await createUser(user.token, userData);
      snackbar.showSuccess();
      navigate("/users");
    } catch (err) {
      handleError(err);
      // snackbar.showError();
    }
  };

  return (
    <>
      <Paper className="odr-card">
        <Box
          component="form"
          onSubmit={onCreateFormSubmit}
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Grid
            container
            rowSpacing={2}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{
              display: "flex",
              //justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography className="heading-title">Create User</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="First Name"
                name="firstname"
                value={userData.firstname}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Last Name"
                name="lastname"
                value={userData.lastname}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                type="tel"
                label="Phone"
                name="phone"
                value={userData.phone}
                inputProps={{ maxLength: 10 }}
                required
                error={!!phoneError}
                helperText={phoneError}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                type="email"
                label="Email"
                name="email"
                value={userData.email}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                label="Role"
                name="role"
                value={userData.role}
                select
              >
                {role
                  .filter((r) => {
                    return user.roles === "REGISTRAR"
                      ? r.Type === "USER"
                      : r.Type;
                  })
                  .map((data, key) => (
                    <MenuItem
                      key={key}
                      value={data.Type}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {data.Type}
                    </MenuItem>
                  ))}
                {/* <MenuItem value="ADMIN">Admin</MenuItem>
                                <MenuItem value="REGISTRAR">Registrar</MenuItem>
                                <MenuItem value="USER">User</MenuItem> */}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Address"
                name="address"
                value={userData.address}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Address Line 2"
                name="address2"
                value={userData.address2}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="City"
                name="city"
                value={userData.city}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="State"
                name="state"
                value={userData.state}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Zipcode"
                name="zipcode"
                value={userData.zipcode}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                select
                label="Country"
                name="country"
                value={userData.country}
              >
                <MenuItem value="">Country</MenuItem>
                {countries.map((c, i) => (
                  <MenuItem key={i} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box display="flex" columnGap={1} justifyContent="flex-end">
                <Link to="/users">
                  <Button
                    size="large"
                    variant="outlined"
                    className="black-boder-button"
                  >
                    Cancel
                  </Button>
                </Link>

                <Grid item xs={12} md={6} lg="auto">
                  <Button
                    size="large"
                    variant="contained"
                    type="submit"
                    className="blue-button"
                    disabled={/^trial_user$/i.test(user.roles) ? true : false}
                  >
                    Create
                  </Button>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}
